import { createLazyComponent } from '@muse-web/router'

export const AsyncFirstLikeDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-first-like' */ './FirstLikeDialogContainer'),
    'FirstLikeDialogContainer',
)
